import { useContext } from 'react'

import { AuthContext } from 'hooks/providers'

export const useUser = () => {
  const user = useContext(AuthContext)
  return { ...user, isLoggedIn: !!user.id }
}
